import { Button } from '@bm-js/atlascloud-ui'
import {
  useCmsEditorActions,
  useCmsEditorStatus,
  useConfirmation,
} from '../../utils/hooks'
import { useTr } from '../../utils/useTr'
import { useMemo } from 'react'
import { TrKey } from '../../cnst/translations/trKey.cnst'
import LinkButton from '../LinkButton'
import { ROUTE } from '../../cnst/router.cnst'
import { useNavigate } from 'react-router'
import { LucideIconName } from '@bm-js/atlascloud-shared'

const CmsEditorTop = () => {
  const { saveConfig, publishConfig } = useCmsEditorActions()
  const { isSaved, isSaving, isPublished, isPublishing } = useCmsEditorStatus()
  const { tr } = useTr()
  const confirmation = useConfirmation()
  const navigate = useNavigate()
  const operationInProgress = useMemo(() => {
    return isSaving || isPublishing
  }, [isSaving, isPublishing])

  const leaveEditor = async () => {
    let proceed = isSaved
    if (!proceed) {
      proceed = await confirmation({
        message: tr(TrKey.editorUnsavedChangesMessage),
        title: tr(TrKey.editorUnsavedChangesTitle),
        proceedText: tr(TrKey.editorUnsavedChangesProceed),
        abortText: tr(TrKey.editorUnsavedChangesAbort),
      })
    }
    if (!proceed) return
    navigate(ROUTE.DASHBOARD)
  }

  return (
    <div className='h-full border-b border-gray-300 flex items-center justify-between px-2 bg-white'>
      <LinkButton
        icon={LucideIconName.SquareArrowLeft}
        reverse
        onClick={leaveEditor}
      >
        {tr(TrKey.editorTopBack)}
      </LinkButton>
      <div className='flex items-center justify-end gap-2'>
        <Button disabled={operationInProgress || isSaved} onClick={saveConfig}>
          {isSaved
            ? tr(TrKey.editorTopSaved)
            : isSaving
              ? tr(TrKey.saving)
              : tr(TrKey.save)}
        </Button>
        <Button
          disabled={operationInProgress || isPublished}
          onClick={publishConfig}
        >
          {isPublished
            ? tr(TrKey.editorTopPublished)
            : isPublishing
              ? tr(TrKey.editorTopPublishing)
              : tr(TrKey.editorTopPublish)}
        </Button>
      </div>
    </div>
  )
}

export default CmsEditorTop
